import {
  FETCH_NECKLACES,
  FETCH_MEMORIES,
  SELECT_ACTIVE_NECKLACE,
  ADD_ACTIVE_MEMORY_BY_INDEX,
  REMOVE_ACTIVE_MEMORY_BY_INDEX,
  RESET_ACTIVE_MEMORIES,
  SET_CALCULATE_NECKLACE_PRICE,
  TOGGLE_MEMORY_COLLECTIONS,
} from "../actions/types";

const INITIAL_STATE = {
  activeNecklace: null,
  activeMemories: [],
  necklaces: null,
  memories: null,
  calculateNecklacePrice: true,
  selectedMemoryCollections: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_NECKLACES:
      return { ...state, necklaces: action.payload };
    case FETCH_MEMORIES:
      return { ...state, memories: action.payload };
    case SELECT_ACTIVE_NECKLACE:
      return { ...state, activeNecklace: action.payload };
    case ADD_ACTIVE_MEMORY_BY_INDEX:
      let newActiveMemoriesAfterAdd = state.activeMemories.slice();
      let foundOldMemory = false;
      if (newActiveMemoriesAfterAdd && newActiveMemoriesAfterAdd.length) {
        for (let i = 0; i < newActiveMemoriesAfterAdd.length; i++) {
          if (action.index === newActiveMemoriesAfterAdd[i].index) {
            newActiveMemoriesAfterAdd[i].memory = action.memory;
            newActiveMemoriesAfterAdd[i].engraving = action.engraving;
            newActiveMemoriesAfterAdd[i].material = action.material;
            foundOldMemory = true;
          }
        }
      }
      if (!foundOldMemory) {
        const memoryObject = {
          memory: action.memory,
          engraving: action.engraving,
          index: action.index,
          material: action.material,
        };
        newActiveMemoriesAfterAdd.push(memoryObject);
      }
      return { ...state, activeMemories: newActiveMemoriesAfterAdd };
    case REMOVE_ACTIVE_MEMORY_BY_INDEX:
      let newActiveMemories = state.activeMemories.slice();
      let removableIndex = action.index;
      newActiveMemories[removableIndex] = null;
      return { ...state, activeMemories: newActiveMemories };
    case RESET_ACTIVE_MEMORIES:
      return { ...state, activeMemories: INITIAL_STATE.activeMemories };
    case SET_CALCULATE_NECKLACE_PRICE:
      return { ...state, calculateNecklacePrice: action.payload };
    case TOGGLE_MEMORY_COLLECTIONS:
      let memoryCollections = state.selectedMemoryCollections;
      const index = memoryCollections.indexOf(action.payload);
      if (index > -1) {
        memoryCollections.splice(index, 1);
      } else {
        memoryCollections.push(action.payload);
      }

      return {
        ...state,
        selectedMemoryCollections: [...memoryCollections],
      };
    default:
      return state;
  }
};
